import React from 'react';
import useMedia from 'use-media';

export const ScreensWithShade = ({ className }) => {
  const isTablet = useMedia({ minWidth: '768px' });
  const isDesktop = useMedia({ minWidth: '1024px' });
  const isWide = useMedia({ minWidth: '1280px' });

  let width = 2500;
  if (isTablet) width = 2100;
  if (isDesktop) width = 2700;
  if (isWide) width = 3000;

  return (
    <svg width={width} viewBox="0 0 2841 3303" fill="none" className={className} style={{ zIndex: -1 }}>
      <path
        d="M2509.42 257.628C2509.42 265.36 2514.85 274.763 2521.54 278.628L2839.88 462.422L0.0966797 3302.22V2509.33L2509.42 0V257.628Z"
        fill="url(#yellowShade)"
      />
      <path
        d="M2509.89 11C2509.89 5.47715 2513.76 3.23858 2518.55 6L2828.23 184.794C2833.01 187.555 2836.89 194.271 2836.89 199.794V460.886C2836.89 466.409 2833.01 468.648 2828.23 465.886L2518.55 287.093C2513.76 284.331 2509.89 277.615 2509.89 272.093V11Z"
        fill="white"
        stroke="#2A4365"
        strokeWidth="8"
      />
      <rect
        width="127.995"
        height="209.163"
        rx="10"
        transform="matrix(0.859406 0.511293 0 1 2569.89 140)"
        fill="white"
        stroke="#2A4365"
        strokeWidth="8"
      />
      <path
        d="M2565.55 243L2583.44 253.333C2584.08 253.702 2584.6 254.597 2584.6 255.333C2584.6 259.015 2587.18 263.492 2590.37 265.333L2597.01 269.167C2600.2 271.008 2602.79 269.515 2602.79 265.833C2602.79 265.097 2603.3 264.798 2603.94 265.167L2620.97 275C2623.84 276.657 2626.17 280.686 2626.17 284V413C2626.17 416.314 2623.84 417.657 2620.97 416L2565.55 384C2562.68 382.343 2560.35 378.314 2560.35 375V246C2560.35 242.686 2562.68 241.343 2565.55 243Z"
        fill="white"
        stroke="#2A4365"
        strokeWidth="8"
      />
      <circle r="3.5" transform="matrix(0.866025 0.5 0 1 2672.92 115.25)" fill="#2A4365" />
      <circle r="3.5" transform="matrix(0.866025 0.5 0 1 2624.92 190.25)" fill="#2A4365" />
      <defs>
        <linearGradient id="yellowShade" x1="2212.88" y1="0" x2="2212.88" y2="3302" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FEEBC8" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
